import Swiper from 'swiper';
import { Navigation, Keyboard, Pagination, FreeMode, Mousewheel } from 'swiper/modules';

/**
 * @class Slider
 *
 * @method constructor
 *     @param {HTMLElement} el
 *
 * Create a slider with buttons
 */
export default class Slider {
    constructor(el) {
        this.el = el;
        this.slider = null;
        this.pagination = this.el.querySelector('.swiper-pagination');

        this.mq = window.matchMedia('(max-width: 1023px)');

        this.init();

        this.mq.addEventListener('change', () => {
            if (this.mq.matches && !this.pagination) {
                this.destroy();
            } else {
                this.init();
            }
        });
    }

    getSlideHeight() {
        const slide = this.el.querySelector('.swiper-slide-active');
        if (!slide) return;

        const slideHeight = slide.offsetHeight + 'px';

        this.el.style.setProperty('--slideHeight', slideHeight);
    }

    init() {
        if (this.slider || (this.mq.matches && !this.pagination)) return;

        this.slider = new Swiper(this.el, {
            modules: [Navigation, Keyboard, Pagination, FreeMode, Mousewheel],
            slidesPerView: 'auto',
            spaceBetween: 10,
            slidesOffsetBefore: 10,
            slidesOffsetAfter: 10,
            duration: 300,
            grabCursor: true,
            keyboard: true,
            freeMode: {
                enabled: true,
                momentum: false
            },
            mousewheel: {
                forceToAxis: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: this.pagination,
                type: 'bullets',
                clickable: true,
            },
            on: {
                init: this.getSlideHeight,
                resize: this.getSlideHeight,
            },
        });
    }

    destroy() {
        if (!this.slider) return;

        this.slider.destroy(true, true);
        this.slider = null;
    }
}
